export default __webpack_public_path__ + "static/media/logo-spiral.1f93b8c8.svg";